import { createContext } from 'react';

export const AutoSelectFirstSlotContext = createContext<boolean>(false);
